import * as types from './types';

const Desc = () => (
  <span>Crea e modifica i dati anagrafici relativi al <br/> gestore.</span>
);

const initialState = {
  listData: {
    id: 'profile',
    title: 'Anagrafica gestore:',
    description:
      <Desc />,
    href: '/profile/account/:id',
    as: '/profile/edit',
    // createLink: '/profile/account/create',
    items: [],
  },
  createOrUpdateInProcess: false,
  itemLoading: false,
  currentItem: {},
  listFetched: false,
  errors: null,
};

const ownerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.OWNERS_GET_SUCCESS:
      return {
        ...state,
        listFetched: true,
        listData: {
          ...state.listData,
          items: [action.payload],
        },
        currentItem: action.payload,
      };
    case types.OWNERS_CREATE_OR_UPDATE_REQUEST:
      return {
        ...state,
        createOrUpdateInProcess: true,
      };
    case types.OWNERS_CREATE_OR_UPDATE_SUCCESS:
      return {
        ...state,
        createOrUpdateInProcess: false,
      };
    case types.OWNERS_CREATE_OR_UPDATE_FAILURE:
      return {
        ...state,
        errors: action.payload,
        createOrUpdateInProcess: false,
      };

    case types.OWNERS_GET_FAILURE:
      return {
        ...state,
        listFetched: true,
      };
    default:
      return state;
  }
};

export default ownerReducer;
